<template>
    <div v-if="mostrarDetalhe">
        <b-row>
            <b-col sm="12" md="12" lg="12" xl="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h6">
                            DETALHAMENTO DA IRREGULARIDADE
                        </span>
                    </b-card-header>
                    <b-card-body>
                        <b-row>
                            <b-col sm="12" md="12" lg="12" xl="12">
                                <detalhe titulo="Descrição" :size="size1">
                                {{ irregularidadeFiscalizacao.descricao }}
                                </detalhe>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="12" md="12" lg="6" xl="6">
                                <detalhe titulo="Gradação" :size="size1">
                                    {{ irregularidadeFiscalizacao.gradacao }}
                                </detalhe>
                            </b-col>
                            <b-col sm="12" md="12" lg="6" xl="6">
                                <detalhe titulo="Status da Conformidade" :size="size1">
                                    {{ irregularidadeFiscalizacao.statusConformidade }}
                                </detalhe>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="12" md="12" lg="6" xl="6">
                                <detalhe titulo="Status da Irregularidade" :size="size1">
                                    {{ irregularidadeFiscalizacao.statusIrregularidade }}
                                </detalhe>
                            </b-col>
                            <b-col sm="12" md="12" lg="6" xl="6">
                                <detalhe titulo="Dias para Correção" :size="size1">
                                    {{ irregularidadeFiscalizacao.diasParaCorrecao }}
                                </detalhe>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="12" md="12" lg="6" xl="6">
                                <detalhe titulo="Data para Correção" :size="size1">
                                    {{irregularidadeFiscalizacao.dataParaCorrecao ? $moment(irregularidadeFiscalizacao.dataParaCorrecao).format('DD/MM/YYYY') : '' }}
                                </detalhe>
                            </b-col>
                            <b-col sm="12" md="12" lg="6" xl="6">
                                <detalhe titulo="Data da Correção" :size="size1">
                                    {{ irregularidadeFiscalizacao.dataCorrecao ?  $moment(irregularidadeFiscalizacao.dataCorrecao).format('DD/MM/YYYY') : '' }}
                                </detalhe>
                            </b-col>
                        </b-row>
                    </b-card-body>
                    <b-card-footer>
                        
                        <app-alterar-dias-correcao v-if="exibirAlterarDiasParaCorrecao"
                            :fiscalizacao="fiscalizacao"
                            :irregularidadeFiscalizacao="irregularidadeFiscalizacao"
                            @onAtualizarDiasParaCorrecao="onAtualizarDiasParaCorrecao()"
                        ></app-alterar-dias-correcao>
                        
                        <b-button v-if="exibirAvaliacao"
                            variant="success"
                            @click.stop="exibirTelaAvaliacao()"
                            class="float-left mr-3">
                            <i class="fa fa-edit  mr-1"></i> Avaliar Irregularidade
                        </b-button>

                        <b-button class="float-left mr-1" variant="danger" @click.stop="voltar()">
                            <span>
                                <i class="fa fa-history mr-1"></i> Voltar
                            </span>
                        </b-button>

                    </b-card-footer>
                </b-card>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12" md="12" lg="12" xl="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h6">
                            HISTÓRICO DE AVALIAÇÕES / CORREÇÕES
                        </span>
                    </b-card-header>
                    <b-card-body>
                        <app-tabela
                            :itens="irregularidadeFiscalizacao.avaliacoes"
                            :campos="campos"
                            :itensPorPagina="itensPorPagina">
                            <template slot="acoes" slot-scope="data">
                                <span class="text-primary">
                                    <i
                                        class="fa fa-info-circle fa-lg icon-button"
                                        title="Visualizar"
                                        @click.stop="selecionarAvaliacao(data)"
                                    ></i>
                                </span>
                            </template>
                        </app-tabela>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
    </div>
    <div v-else>
        <router-view></router-view>  
    </div>
</template>

<script>
import FiscalizacoesServicos from '../FiscalizacoesServicos'
import AlterarDiasCorrecao from '../alterarDiasCorrecao/alterarDiasCorrecao.vue'
import StatusConformidade from '../enum/StatusConformidadeEnum'
import StatusIrregularidade from '../enum/StatusIrregularidadeEnum'

export default {

    components: {
        AppAlterarDiasCorrecao: AlterarDiasCorrecao,
    },

    data() {
        return {
            campos: [
                {
                    key: 'descricao',
                    label: 'Descrição',
                    filterable: true,
                    sortable: true,
                },
                {
                    key: 'origem',
                    label: 'Origem',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'dataAvaliacao',
                    label: 'Data',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                },
            ],
            itensPorPagina: 10,
            size1: '150',
            historicoAvaliacaoCorrecao: [],
            irregularidadeFiscalizacao: {},
            fiscalizacaoId: null,
            idIrregularidadeFiscalizacao: null,
            fiscalizacao: null
        }
    },
    methods: {

        selecionarAvaliacao(data) {
            this.$router.push({
                name: `IrregularidadeFiscalizacao_Avaliacao`,
                params: {
                    fiscalizacaoId: this.fiscalizacaoId,
                    idIrregularidadeFiscalizacao: this.idIrregularidadeFiscalizacao,
                    idAvaliacaoIrregularidade: data.idAvaliacaoIrregularidade
                }
            })
        },

        exibirTelaAvaliacao() {
            this.$router.push({
                name: `IrregularidadeFiscalizacao_Avaliar`,
                params: {
                    fiscalizacaoId: this.fiscalizacaoId,
                    idIrregularidadeFiscalizacao: this.idIrregularidadeFiscalizacao
                }
            })
        },

        voltar(data) {
            this.$router.push({
                name: `Fiscalizações_Detalhar`,
                params: {
                    fiscalizacaoId: this.fiscalizacaoId
                }
            })
        },

        obterIrregularidadeFiscalizacao(idIrregularidadeFiscalizacao) {
            this.$store.dispatch('addRequest')
            FiscalizacoesServicos
                .obterIrregularidadeFiscalizacao(idIrregularidadeFiscalizacao).then(response => {
                if (response) {
                    if (response.success) {
                        this.irregularidadeFiscalizacao = response.data
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        voltarParaListagemIrregularidades() {
            this.$emit('onListarIrregularidades')
        },

        onAtualizarDiasParaCorrecao(diasParaCorrecao) {
            this.obterIrregularidadeFiscalizacao(this.idIrregularidadeFiscalizacao)
        }
    },

    watch: {
        combinedProps: {
            handler(newVal) {
                if (newVal.every(val => val !== null && !(Array.isArray(val) && val.length === 0))) {
                    this.obterIrregularidadeFiscalizacao(this.idIrregularidadeFiscalizacao)
                }
            },
            deep: true, // Necessário para observar mudanças nos valores dentro do array
            immediate: true, // Opcional: executa no início
        },

        $route(to, from) {
            if (from.name === 'IrregularidadeFiscalizacao_Avaliar' || from.name === 'IrregularidadeFiscalizacao') {
                this.obterIrregularidadeFiscalizacao(this.idIrregularidadeFiscalizacao)
            } 
        },
    },

    validations: {
    },

    computed: {
        exibirAlterarDiasParaCorrecao() {
            return this.irregularidadeFiscalizacao && this.irregularidadeFiscalizacao.numeroStatusConformidade === StatusConformidade.NAO_FISCALIZADO
        },

        exibirAvaliacao() {
            return this.irregularidadeFiscalizacao && (
                this.irregularidadeFiscalizacao.numeroStatusConformidade === StatusConformidade.NAO_FISCALIZADO ||
                (this.irregularidadeFiscalizacao.numeroStatusConformidade === StatusConformidade.NAO_CONFORME && 
                this.irregularidadeFiscalizacao.numeroStatusIrregularidade === StatusIrregularidade.CORRECAO_EM_ANALISE)
            )
        },
    
        combinedProps() {
            return [this.fiscalizacaoId, this.idIrregularidadeFiscalizacao];
        },

        mostrarDetalhe() {
            return this.$route.name === 'IrregularidadeFiscalizacao_Detalhe'
        }
    },

    created() {
        this.fiscalizacaoId = this.$route.params.fiscalizacaoId
        this.idIrregularidadeFiscalizacao = this.$route.params.idIrregularidadeFiscalizacao
    },

}
</script>
